(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/youtube-video.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/youtube-video.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
var Icon = svs.ui.ReactIcon;
var trackEvent = svs.components.analytics.trackEvent;
var isSafari = svs.core.detect.browser.safari();
var YoutubeVideo = function YoutubeVideo(_ref) {
  var videoId = _ref.videoId,
    src = _ref.src,
    heightPercent = _ref.heightPercent,
    height = _ref.height,
    width = _ref.width,
    title = _ref.title,
    thumbnailUrl = _ref.thumbnailUrl,
    fitWrapper = _ref.fitWrapper,
    jsonLDTags = _ref.jsonLDTags,
    webpThumbnailUrl = _ref.webpThumbnailUrl;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    renderIframe = _useState2[0],
    setRenderIframe = _useState2[1];
  var scriptRef = useRef(null);
  useEffect(function () {
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = jsonLDTags;
    var currentScriptDiv = scriptRef.current;
    if (currentScriptDiv) {
      currentScriptDiv.appendChild(script);
    }
    return function () {
      if (currentScriptDiv) {
        currentScriptDiv.removeChild(script);
      }
    };
  }, [jsonLDTags]);
  var renderYoutubePlayer = function renderYoutubePlayer() {
    setRenderIframe(true);
    var videoLabel = "".concat(videoId, "-").concat(title) || "".concat(videoId);
    trackEvent({
      action: 'Start',
      category: 'Video',
      opt_label: videoLabel,
      opt_value: 1
    });
  };
  return React.createElement("div", {
    className: "js-youtube-video-container youtube-video-container react-yt-video ".concat(fitWrapper ? 'youtube-video-container-fit' : ''),
    "data-video-id": videoId,
    itemProp: "video",
    itemScope: true,
    itemType: "http://schema.org/VideoObject",
    ref: scriptRef,
    style: heightPercent ? {
      paddingBottom: "".concat(heightPercent, "%")
    } : null
  }, renderIframe && React.createElement("iframe", {
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    alt: title,
    className: "js-youtube-video-iframe js-youtube-video-".concat(videoId, " youtube-video-iframe"),
    "data-videoid": videoId,
    height: height,
    id: "js-youtube-video-".concat(videoId),
    src: "".concat(src, "&").concat(isSafari ? 'autoplay=1&mute=1' : 'autoplay=1', "&origin=").concat(window.location.origin),
    title: title,
    width: width
  }), !renderIframe && React.createElement("div", {
    className: "youtube-video-player js-youtube-video-player",
    onClick: renderYoutubePlayer
  }, React.createElement("picture", {
    className: "youtube-video-thumbnail-wrapper"
  }, webpThumbnailUrl && React.createElement(React.Fragment, null, React.createElement("source", {
    media: "(min-width: 1280px)",
    srcSet: "".concat(webpThumbnailUrl, "/maxresdefault.webp"),
    type: "image/webp"
  }), React.createElement("source", {
    media: "(min-width: 640px)",
    srcSet: "".concat(webpThumbnailUrl, "/sddefault.webp"),
    type: "image/webp"
  }), React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: "".concat(webpThumbnailUrl, "/hqdefault.webp"),
    type: "image/webp"
  }), React.createElement("source", {
    media: "(min-width: 320px)",
    srcSet: "".concat(webpThumbnailUrl, "/mqdefault.webp"),
    type: "image/webp"
  })), React.createElement("source", {
    media: "(min-width: 1280px)",
    srcSet: "".concat(thumbnailUrl, "/maxresdefault.jpg"),
    type: "image/jpeg"
  }), React.createElement("source", {
    media: "(min-width: 640px)",
    srcSet: "".concat(thumbnailUrl, "/sddefault.jpg"),
    type: "image/jpeg"
  }), React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: "".concat(thumbnailUrl, "/hqdefault.jpg"),
    type: "image/jpeg"
  }), React.createElement("source", {
    media: "(min-width: 320px)",
    srcSet: "".concat(thumbnailUrl, "/mqdefault.jpg"),
    type: "image/jpeg"
  }), React.createElement("img", {
    className: "youtube-video-thumbnail",
    height: height,
    src: "".concat(thumbnailUrl, "/default.jpg"),
    title: title,
    width: width
  })), React.createElement("div", {
    className: "youtube-video-icon"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "play",
    size: "800"
  }))));
};
svs.components.youtube_video.YoutubeVideo = YoutubeVideo;

 })(window);